import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'

export default class GigUnavailableChatMessage extends AbstractChatMessage {
  constructor(data: LX.GigUnavailableChatMessage) {
    super(data)
    this.body = data.body
  }

  static fromServer(data: LX.GigUnavailableChatMessage) {
    return new GigUnavailableChatMessage(data)
  }

  getShortMessage() {
    return 'This Gig was removed by the Talent.'
  }
}
